'use client'
import { CheckmarkSmallIcon } from '../../../icons'
import React from 'react'
import { FormatOptionLabelMeta } from 'react-select/dist/declarations/src/Select'
import { TextTypes } from '../../../../types'
import { Text } from '../../../atoms/Text'
import { SelectOption } from '../../../../types/SelectInput'

export const MultiLineOption = (option: SelectOption, meta: FormatOptionLabelMeta<SelectOption>): JSX.Element => {
    const hasFooter: boolean = option.footer !== undefined && option.footer !== null

    return (
        <div
            className="flex items-center justify-between"
            data-cy={`input-select-option__value-${option.value}__label-${option.label}`}
            data-testid="select-input-option"
        >
            <div className="inline-flex flex-col grow min-w-0">
                <Text className="text-wrap break-words">{option.label}</Text>
                {hasFooter && (
                    <Text type={TextTypes.SMALL_TEXT} className="text-wrap break-words">
                        {option.footer}
                    </Text>
                )}
            </div>
            {meta.selectValue.map((selectedOption: SelectOption) => selectedOption.value).includes(option.value) && (
                <CheckmarkSmallIcon className="ml-4 text-text-interactive shrink-0" />
            )}
        </div>
    )
}
